import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';

import { ToastrService } from 'ngx-toastr';
import { ApisService } from '../../services/apis.service';
import {SilkService} from '../../services/silk.service';

@Component({
  selector: 'app-race-withdrawn',
  templateUrl: './race-withdrawn.component.html',
  styleUrls: ['./race-withdrawn.component.scss']
})
export class RaceWithdrawnComponent implements OnInit {
  @Input() runner;
  @Input() isWithdrawnPostResult: boolean = false;
  meta: {
    feesSelected: boolean;
    saveEnabled: boolean;
    saving: boolean;
  };
  userId: number;
  withdrawnReasons: any[];
  raceWithdrawn: {
    withdrawnCode: number;
    declaredTime: any;
  };

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApisService,
    private notification: ToastrService,
    public silkService: SilkService
  ) { }

  ngOnInit() {
    console.log(this.runner);
    this.meta = {
      feesSelected: this.runner.withdrawnFeePaid,
      saveEnabled: false,
      saving: false
    };

    this.raceWithdrawn = {
      withdrawnCode: this.runner.withdrawnFeePaid === 1 ? 98 : 99,
      declaredTime: moment(this.runner.withdrawnTimestamp).isValid()
      ? {hour: moment(this.runner.withdrawnTimestamp).hours(), minute: moment(this.runner.withdrawnTimestamp).minutes()}
      : null
    };

    this.meta.feesSelected = this.runner.withdrawnFeePaid === 1 ? true : false;

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });
  }

  checkPayload(value) {
    this.meta.saveEnabled = false;
    this.raceWithdrawn.withdrawnCode = value === true ? 98 : 99;
    if (this.raceWithdrawn.declaredTime === null) {
      this.raceWithdrawn.declaredTime = { hour: moment().hours(), minute: moment().minutes()};
    }
    this.meta.saveEnabled = true;
  }

  confirm() {
    this.meta.saving = true;
    const payload = {
      animalId: this.runner.animalId,
      yearOfRace: this.runner.yearOfRace,
      raceId: this.runner.raceId,
      divisionSequence: this.runner.divisionSequence,
      withdrawnFeePaid: Number(this.raceWithdrawn.withdrawnCode) === 98,
      withdrawnPostResult: this.isWithdrawnPostResult ? moment(this.raceWithdrawn.declaredTime).format('YYYY-MM-DD HH:mm:ss') : null,
      withdrawnTimestamp: moment(this.raceWithdrawn.declaredTime).format('YYYY-MM-DD HH:mm:ss'),
      // jockeyId: this.runner.jockeyId,
      updatedBy: this.userId
    };

    this.apiService.updateWithdrawn(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
      .subscribe(
        res => {
          // console.log('[ DEBUG ] Jockey Data Saved:', res);
          this.activeModal.close(res);
          this.notification.success(`${this.runner.animalName}` +
            ` has been updated as ${this.raceWithdrawn.declaredTime ? 'Withdrawn' : 'Non Runner'}.`, 'Withdrawn'
          );
        },
        err => {
          if (err.error.withdrawnCode || err.error.withdrawnFeePaid) {
            this.notification.warning(`You're not authorized to change the status for this entry.`, 'Unauthorized', { timeOut: 6000 });
          } else {
            console.error('[ DEBUG ] Error updating non runner status', err);
            this.notification.error(`Could't update the status of this runner. Check your connection and Try again.`, 'Withdrawn');
          }
          this.meta.saving = false;
        }
      );
  }

  delete() {
    this.meta.saving = true;
    const payload = {
      animalId: this.runner.animalId,
      yearOfRace: this.runner.yearOfRace,
      raceId: this.runner.raceId,
      divisionSequence: this.runner.divisionSequence,
      // jockeyId: this.runner.jockeyId,
      withdrawnFeePaid: null,
      withdrawnTimestamp: null,
      updatedBy: this.userId
    };
    this.meta.saving = true;
    this.apiService.updateWithdrawn(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
      .subscribe(
        res => {
          this.activeModal.close(res);
          this.notification.success(`${this.runner.animalName} withdrawn status has been revoked.`, 'Withdrawn');
        },
        err => {
          if (err.error.withdrawnCode || err.error.withdrawnFeePaid) {
            this.notification.warning(`You're not authorized to change the status for this entry.`, 'Unauthorized');
          } else {
            console.error('[ DEBUG ] Error updating non runner status', err);
            this.notification.error(`Could't update the status of this runner. Check your connection and Try again.`, 'Withdrawn');
          }
          this.meta.saving = false;
        }
      );
  }

  cancel(action) {
    this.activeModal.dismiss(action);
  }

}
